import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalido?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalido, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          'h-10 w-full px-3 rounded-md border bg-white text-sm text-slate-900 placeholder:text-slate-400 transition outline-none',
          'focus-visible:ring-2 focus-visible:ring-offset-1',
          invalido
            ? 'border-red-400 focus-visible:ring-red-500'
            : 'border-slate-300 focus-visible:border-institutional focus-visible:ring-institutional',
          'disabled:opacity-60 disabled:bg-slate-50',
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
